import React, { useEffect, useState } from 'react';
import './VersePreview.css';
import TeachingTip from './TeachingTip';
import './TeachingTip.css';
import * as DatabaseUtil from '../utils/databaseUtil';
import * as FallbackUtil from '../utils/databaseUtilFallback';

/**
 * VersePreview Component - Displays Quran verses with optional teaching tips
 * 
 * @param {Object} props
 * @param {Array} props.verses - Array of verse objects to display
 * @param {Object} props.teachingTips - Object containing teaching tips with keys in format "surahId:ayahNumber"
 * @param {boolean} props.loading - Loading state
 * @param {Function} props.onClose - Function to call when close button is clicked
 */
const VersePreview = ({ verses = [], teachingTips = {}, loading = false, onClose }) => {

  if (loading) {
    return (
      <div className="verse-preview-container">
        <div className="verse-preview-header">
          <h2>Verse Preview</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading verses...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="verse-preview-container">
      <div className="verse-preview-header">
        <h2>Verse Preview</h2>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      <div className="verse-preview-content">
        {verses.length === 0 ? (
          <p className="no-verses">No verses to display. Please select a valid verse range.</p>
        ) : (
          verses.map((verse) => {
            const translation = verse.translation || "Translation not available for this verse";
            
            return (
              <div key={`verse-${verse.number}`} className="verse-item">
                <div className="verse-number">Verse {verse.numberInSurah}</div>
                <div className="verse-text">{verse.text}</div>
                <TeachingTip text={translation} />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default VersePreview;